import axios from 'axios';
import authHeader from '/src/services/auth.header';

const API_URL = process.env.VUE_APP_API_URL

class CustomerService {
    get(id, params = {}) {
        return axios.get(
            `${API_URL}customer/${id}/`,
            {headers: authHeader(), params: params})
    }

    patch(id, data = {}) {
        return axios.patch(
            `${API_URL}customer/${id}/`,
            data,
            {headers: authHeader()}
        )
    }

    post(data = {}) {
        return axios.post(
            `${API_URL}customer/`,
            data,
            {headers: authHeader()}
        )
    }

    list(params) {
        return axios.get(
            `${API_URL}customer/`,
            {headers: authHeader(), params: params}
        )
    }

    delete(id) {
        return axios.delete(
            `${API_URL}customer/${id}/`,
            {headers: authHeader()}
        )
    }
}

export default new CustomerService();
